import React, { useState, useEffect, useCallback } from "react";
import { FileDown, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { exportAnalysisPdf } from "@/lib/pdf";

// Reusable "Download PDF" — captures a live analysis node into a branded OCTON report.
export const DownloadPdfButton = ({ targetRef, title, subtitle, meta = [], filename, label = "Download PDF", className = "", testid = "download-pdf-btn" }) => {
  const [busy, setBusy] = useState(false);
  const run = useCallback(async () => {
    const node = targetRef?.current;
    if (!node) { toast.error("Nothing to export yet"); return; }
    setBusy(true);
    try {
      await exportAnalysisPdf({ node, title, subtitle, meta, filename });
      toast.success("PDF report downloaded");
    } catch (e) {
      toast.error("Could not build the PDF");
    } finally { setBusy(false); }
  }, [targetRef, title, subtitle, meta, filename]);

  // Let the OCTON voice agent trigger this export by voice ("download the report").
  useEffect(() => {
    const h = () => { if (targetRef?.current) run(); };
    window.addEventListener("octon:download-report", h);
    return () => window.removeEventListener("octon:download-report", h);
  }, [run, targetRef]);

  return (
    <button onClick={run} disabled={busy} data-testid={testid}
      className={`inline-flex items-center gap-2 rounded-full border border-white/15 px-4 py-2 text-xs font-semibold text-white/80 transition hover:border-cyan-400/50 hover:text-white disabled:opacity-50 ${className}`}>
      {busy ? <Loader2 className="animate-spin" size={14} /> : <FileDown size={14} />} {busy ? "Building…" : label}
    </button>
  );
};
